<div [style.z-index]="loaderData?.level" *ngIf="loaderData?.show && showSpinner()">
  <div class="loader" [hidden]="loaderData?.hide" [ngClass]="{'hide': isVisible}"></div>
</div>